import { Finder, IFinder } from "../finder/IFinder";
import { ITechnologia } from "./ITechnologia";

export class Technologia implements ITechnologia {
    /*[id] [int] IDENTITY(1,1) NOT NULL,
	[kalk_id] [int] NOT NULL,
	[etap_id] [int] NOT NULL,
	[typ] [nvarchar](40) NULL,
	[etap_typ] [nvarchar](40) NULL,
	[komponent_id] [nvarchar](40) NULL,
	[komponent_typ] [nvarchar](40) NULL,
	[komponent_nazwa] [nvarchar](40) NULL,
	[komponent_exact] [int] NULL,
	[komponent_exact_metry] [int] NULL,
	[komponent_kolor] [nvarchar](40) NULL,
	[komponent_polysk] [nvarchar](40) NULL,
	[komponent_podklad] [nvarchar](40) NULL,
	[komponent_grubosc_podkladu] [nvarchar](40) NULL,
	[komponent_cena] [decimal](18, 2) NULL,
	[komponent_jm] [char](5) NULL,
	[komponent_lead_time] [int] NULL,
	[zmiana] [int] NULL,
	[procent] [int] NULL,
	[procent_pokrycia] [int] NULL,
	[krotnosc] [int] NULL,
	[list_order] [int] NULL,
	[newfoil_x] [decimal](18, 2) NULL,
	[newfoil_y] [decimal](18, 2) NULL,
	[newfoil_u] [decimal](18, 2) NULL,
	[newfoil_koszt_płytki] [decimal](18, 2) NULL,
	[newfoil_koszt_matrycypatrycy] [decimal](18, 2) NULL,
    */
    id:number|undefined
	kalk_id:number|undefined
	etap_id:number|undefined
	typ:string=''
	etap_typ?:string

	technologia_studio: string = ""
    etap_studio: string = ""
    kolor_studio: string = ""

	komponent_id:number=0
	komponent_typ:string=''
	komponent_nazwa:string=''
	komponent_exact:number=0
	komponent_exact_metry:number=0
	komponent_kolor:string=''
	komponent_polysk:string=''
	komponent_podklad:string=''
	komponent_grubosc_podkladu:number=0
	komponent_cena:number=0
	komponent_jm:string=''
	komponent_lead_time:number=0
	komponent_wydatek:number= 0
	komponent_wydatek_sita_puchn:number=0;


	zmiana:number=0
	procent:number=100
	procent_pokrycia:number=100
	krotnosc:number=1
	list_order:number=0
	newfoil_x:number=0
	newfoil_y:number=0
	newfoil_z:number=0
	newfoil_u:number=0;
	newfoil_koszt_płytki:number=0
	newfoil_koszt_matrycypatrycy:number=0
	komponent_finder:IFinder = new Finder()
	komponent_farba_finder:IFinder = new Finder()
	kolor:any;
	komponent_surowiec_handlowy_a: string='';
	komponent_szerokosc: number|undefined = undefined;
	color_preview: string=""

	file_path_128: string = ""
	proofscope_url: string = ""
	separacja_url:string = ""


	surowiec = {
		surowiec_id: undefined,
		surowiec_idm: undefined,
		il_rek: 0,
		szerokosc:0
	}


	copy_komponent(k:any) {
		this.komponent_id=k.data_komponent_id;
		this.komponent_typ=k.data_komponent_typ;
		this.komponent_nazwa=k.data_komponent_nazwa;
		this.komponent_exact=k.data_komponent_exact;
		this.komponent_exact_metry=k.data_komponent_exact_metry;
		this.komponent_kolor=k.data_komponent_kolor;
		this.komponent_polysk=k.data_komponent_polysk;
		this.komponent_podklad=k.data_komponent_podklad;
		this.komponent_grubosc_podkladu=k.data_komponent_grubosc_podkladu;
		this.komponent_cena=k.data_komponent_cena;
		this.komponent_jm=k.data_komponent_jm;
		this.komponent_lead_time=k.data_komponent_lead_time;
		this.komponent_surowiec_handlowy_a=k.data_surowiec_handlowy_a;
	}

	
	
}

